module.exports = __webpack_public_path__ + "static/img/logo_imesp_azul.2593845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_imesp_azul.png
// module id = xSCS
// module chunks = 232